import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MinioDeploymentDetails } from "api/controlPlaneApi";
import { LoadingStatus } from "common/types";

export interface DeploymentsState {
  deployments: MinioDeploymentDetails[];
  totalRows: number;
  offset: number;
  resultsPerPage: number;
  status: LoadingStatus;
}

const initialState: DeploymentsState = {
  deployments: [],
  totalRows: 0,
  offset: 0,
  resultsPerPage: 20,
  status: "idle",
};

export const deploymentsSlice = createSlice({
  name: "deployments",
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<LoadingStatus>) => {
      state.status = action.payload;
    },
    setOffset: (state, action: PayloadAction<number>) => {
      state.offset = action.payload;
    },
    resetRows: (state) => {
      state.deployments = [];
    },
    resetDeploymentsState: () => {
      return initialState;
    },
  },
});

export const { setStatus, setOffset, resetRows, resetDeploymentsState } =
  deploymentsSlice.actions;

export default deploymentsSlice.reducer;
